import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10864d80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "d-flex justify-center align-center circle" }
const _hoisted_3 = { class: "text-center text-styled" }
const _hoisted_4 = {
  key: 0,
  class: "text-subtitle text-center"
}
const _hoisted_5 = { class: "d-flex justify-center area-btns" }

import { withDefaults, ref, watch } from 'vue';
import { MoleculeModal } from '.';
import * as comps from '@/components/atoms';
import AtomInput from '../atoms/AtomInput.vue';

interface IProps {
  icon?: string;
  text?: string;
  description?: string;
  iconColor?: string;
  showAlertConfirm: boolean;
  isText?: boolean;
  isDescription?: boolean;
  label?: string;
  textConfirmButton?: string;
  showCancelButton?: boolean;
  isLoading?: boolean;
  hint?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModalAlert',
  props: {
    icon: {},
    text: {},
    description: {},
    iconColor: {},
    showAlertConfirm: { type: Boolean },
    isText: { type: Boolean, default: false },
    isDescription: { type: Boolean },
    label: {},
    textConfirmButton: {},
    showCancelButton: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
    hint: {}
  },
  emits: ['cancel', 'confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const reason = ref<string>('');

const emit = __emit;

function handleCancel() {
  emit('cancel');
}

function handleConfirm() {
  emit('confirm', reason.value);
}

watch(() => props.showAlertConfirm, (newValue) => {
  if (newValue === true) {
    reason.value = "";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    "padding-y": "32px",
    width: "390px",
    onHandleCancel: handleCancel,
    title: "Logout",
    showHeader: false,
    showFooter: false,
    persistent: false,
    show: props.showAlertConfirm,
    "btn-close-text": "Cancelar"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (props.icon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.icon]), {
                key: 0,
                style: {"width":"40px","height":"40px","fill":"var(--components-main100)"},
                color: props.iconColor
              }, null, 8, ["color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(props.text), 1)
        ]),
        (props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(props.description), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "content"),
        (props.isText)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 1,
              cols: "12",
              "align-self": "start",
              class: "pa-0"
            }, {
              default: _withCtx(() => [
                _createVNode(AtomInput, {
                  modelValue: reason.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
                  classes: "w-100 pt-6",
                  "prepend-icon": false,
                  placeholder: props.hint,
                  "is-description": _ctx.isDescription,
                  label: _ctx.label,
                  height: _ctx.isDescription ? '100px' : '56px',
                  "has-error": false
                }, null, 8, ["modelValue", "placeholder", "is-description", "label", "height"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (props.showCancelButton)
            ? (_openBlock(), _createBlock(comps.AtomButton, {
                key: 0,
                onClick: handleCancel,
                classes: "btn-cancel btn-size",
                text: "Voltar"
              }))
            : _createCommentVNode("", true),
          _createVNode(comps.AtomButton, {
            onClick: handleConfirm,
            classes: "btn-confirm btn-size",
            text: props.textConfirmButton || 'Sim',
            isLoading: props.isLoading
          }, null, 8, ["text", "isLoading"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})